import * as React from 'react';
import { Wrapper, Title, Description, Link } from './styled';
import { ASSESORS } from '@app/src/config/footer';

interface Props {
  className?: string;
}

export const Assesors: React.FC<Props> = ({ className }) =>
  <Wrapper className={className}>
    <Title>Asesores comerciales</Title>
    {
      ASSESORS &&
      <Description>
        {
          ASSESORS.map((assesor, key) => (
            <li key={key}><Link href={`mailto:${assesor}`}>{assesor}</Link></li>
          ))
        }
      </Description>
    }
  </Wrapper>
